export default __webpack_public_path__ + "static/cee-91cb33df9d2618b0681ecb47b1cfa011.png";